import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import PurchaseModal from 'components/PurchaseModal/PurchaseModal';

const TableData = ({ schedule, dateNowIndex, rowIndex, selectedDate, activeModal, onModalClick, width, title, hours, minutes, brandClass }) => (
  <td
    className={
      `react-movie-table-data react-mozi-brand ${brandClass} ${dateNowIndex === rowIndex && selectedDate === moment().format('YYYYMMDD') ? ' disabled' : ''}`
    }
  >
    <div className="react-movie-table-data-container">
      {schedule === ''
        ? <div>&nbsp;</div>
        : schedule.map((date, index) => (
          <PurchaseModal
            {...date}
            key={index.toString()}
            width={width}
            tabIndex={index.toString()}
            handleClick={() => onModalClick({
              title,
              playtime: date.playtime,
            })}
            hours={hours}
            minutes={minutes}
            selectedDate={selectedDate}
            brandClass={brandClass}
            active={activeModal.title === title && activeModal.playtime === date.playtime}
            inverz
          />
        ))
      }
    </div>
  </td>
);

TableData.propTypes = {
  schedule: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({
      playtime: PropTypes.string,
    })),
    PropTypes.string,
  ]).isRequired,
  dateNowIndex: PropTypes.number,
  rowIndex: PropTypes.number.isRequired,
  selectedDate: PropTypes.string.isRequired,
  activeModal: PropTypes.shape({}).isRequired,
  onModalClick: PropTypes.func.isRequired,
  width: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  brandClass: PropTypes.string,
  hours: PropTypes.number,
  minutes: PropTypes.number,
};

TableData.defaultProps = {
  dateNowIndex: null,
  hours: new Date().getHours(),
  brandClass: 'react-artmozi',
  minutes: new Date().getMinutes(),
};

export default TableData;
